import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M12.68 1.95996H3.33C2.19 1.95996 1.25 2.88996 1.25 4.02996V13.3C1.25 13.71 1.59 14.05 2 14.05H14C14.42 14.05 14.75 13.71 14.75 13.3V4.02996C14.75 2.88996 13.82 1.95996 12.68 1.95996V1.95996ZM2.75 6.74996H5.52V12.55H2.75V6.74996ZM13.25 12.55H7.01V6.74996H13.24V12.55H13.25ZM13.25 5.24996H2.75V4.02996C2.75 3.71996 3.02 3.45996 3.33 3.45996H12.68C13 3.45996 13.25 3.70996 13.25 4.02996V5.24996Z';
const draw24px = 'M19.12 3.23999H4.98999C3.47999 3.23999 2.23999 4.46999 2.23999 5.98999V19.98C2.23999 20.4 2.57999 20.73 2.98999 20.73H21.12C21.53 20.73 21.87 20.4 21.87 19.98V5.98999C21.87 4.46999 20.63 3.23999 19.12 3.23999ZM3.73999 8.74999H7.95999V19.23H3.73999V8.74999ZM20.37 19.23H9.45999V8.74999H20.37V19.23V19.23ZM20.37 7.24999H3.73999V5.98999C3.73999 5.29999 4.29999 4.73999 4.98999 4.73999H19.12C19.81 4.73999 20.37 5.29999 20.37 5.98999V7.24999V7.24999Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const AccViewerIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'accViewer'));
AccViewerIcon.displayName = 'AccViewerIcon';
AccViewerIcon.propTypes = Icon.propTypes;
AccViewerIcon.renderIcon = props => /*#__PURE__*/React.createElement(AccViewerIcon, props);
export default AccViewerIcon;
//# sourceMappingURL=AccViewerIcon.js.map